import React from 'react';
import '../app.css'
import Footer from '../components/Footer';
import Header from '../components/Header';
import BounceBackLanding from '../components/landing/BounceBackLanding';
import FactsLanding from '../components/landing/FactsLanding';
import IncomeMaxMessengerComponent from '../components/landing/IncomeMaxMessenger';
import ReadyLearnLandingComponent from '../components/landing/ReadyLearnLanding';
const LandingPage = () => {

    return (
     <>
      <Header />
        <BounceBackLanding />
        <FactsLanding />
        <IncomeMaxMessengerComponent />
        <ReadyLearnLandingComponent />
        <Footer />
    </>
    )
}

export default LandingPage;